import { useEffect, useState } from 'react';
import { ToggleProps, ToggleSize } from './types';

import './toggle.css';

export default function ToggleInput({
  title,
  disabled,
  onChange,
  value,
  checked = false,
  name,
  className = '',
  size = ToggleSize.SMALL,
  tabIndex,
  visualClassName = '',
}: ToggleProps): React.JSX.Element {
  const [isChecked, setIsChecked] = useState(checked);

  useEffect(() => {
    setIsChecked(checked);
  }, [checked]);

  return (
    <label
      htmlFor={`toggle-${name}`}
      className={`toggle-button-wrapper toggle-${size} ${className}`}
      tabIndex={-1}
    >
      <input
        type="checkbox"
        name={name}
        className="toggle"
        id={`toggle-${name}`}
        disabled={disabled}
        onChange={(e) => onChange && onChange(e)}
        checked={isChecked}
        value={value}
        autoComplete="off"
        tabIndex={tabIndex}
      />
      <div className={`visual ${visualClassName}`}>{title || ''}</div>
    </label>
  );
}
